export enum ExecutiveSummaryTypeEnum {
    Phase,
    AnalysisItem,
    Infraction
}